import dayjs from 'dayjs';

// Le tabelle Dash_* hanno di norma dati fino a oggi - 3 giorni (UPDATE_DASH_DATASOURCES ricalcola
// da T-6 e i dati sorgente arrivano con ritardo): oltre questo limite i grafici sarebbero vuoti.
export const DATA_LAG_DAYS = 3;

export const getLastAvailableDay = () => dayjs().subtract(DATA_LAG_DAYS, 'day').endOf('day');

export const getDefaultEndDate = () => getLastAvailableDay();

export const getDefaultStartDate = () => getLastAvailableDay().subtract(1, 'week').startOf('day');
